/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FieldNumber(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FieldNumber',
      'aria-hidden': true,
      focusable: false,
      width:  31 * scale,
      height: 29 * scale,
      viewBox: '0 0 31 29',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M29.688 11 30 9h-7.888l1.482-8h-1.906l-1.482 8h-8l1.482-8h-2l-1.482 8H2.188l-.5 2h8.148L8.54 18H1.188l-.312 2H8.17l-1.482 8h2l1.482-8h8l-1.482 8h1.906l1.482-8h8.612L29 18h-8.554l1.296-7zm-11.15 7h-8l1.297-7h8z"}))
}
